import styled from 'styled-components';
import { MainTheme } from '@paretogroup/tess';

export const AvailableFiltersWrapper = styled.div`
  width: 100%;
`;

export const Text = styled.h2`
  font-size: 14px;
  line-height: 16px;
  font-weight: 400;
  color: {${MainTheme.colors['regal-blue-50']}};
  display: block;
`;

export const TextWrapper = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
`;
